/**
 * Signing party state within an e-signature envelope
 */
export class ESignatureRecipientDto {
	email?: string;
	name?: string;
	hasSigned?: boolean;
	signedAt?: Date;
}
